import type { FaireProductEntity } from "../../entity_types/product";

export const p_9c8fhy9kp3: FaireProductEntity = {
  token: "p_9c8fhy9kp3",
  type: "product",
  name: "Striped Sage Tan Bear Cardigan",
  brandToken: "b_dg7nau6taf",
  brandName: "Loralin Design",
  imageUrl:
    "https://cdn.faire.com/fastly/1705ea466918805197144800148aa9d9776ffb7a9243a48ca631c771c86e4b08.jpeg",
  galleryImageUrls: [],
  priceDollars: 26,
  description:
    "Introducing our Striped Bear Cardigan by Loralin Design. Designed with your baby's comfort in mind, this beautifully knit sweater is perfect for the fall and winter seasons. Made from 100% cotton, it's gentle on your baby's skin and ensures they stay warm and cozy. The cardigan features a playful bear design and comes in a size that's ideal for babies aged 0-9 months. Easy to care for, you can keep it looking its best with a simple machine wash. This cardigan is more than just clothing, it's a keepsake you'll want to cherish.",
  tags: [],
  msrpDollars: 52,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:51.765Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
